import { render, staticRenderFns } from "./admin-payments.vue?vue&type=template&id=9fa9ae7e"
import script from "./admin-payments.vue?vue&type=script&lang=js"
export * from "./admin-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports